import React from 'react';
import { render } from 'react-dom';
import App from './Components/App';
import Desktop from './Components/mobile'

const root = document.getElementById('root');
//const root = ReactDOM.createRoot(document.getElementById('root'));

const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const isMobileView = regex.test(navigator.userAgent);

render(
  <React.StrictMode>
    { isMobileView ? <Desktop /> : <App /> }
  </React.StrictMode>,
    root
);

